///
/// EarthBrowser
///
/// Created by Matt Giger on 10/24/2026
/// Copyright (c) 2026 Geodata Labs
///

// Module-level so engine objects without a context reference (Transform,
// Canvas, NodeBase) can flag that the next frame should be drawn. Stovokor
// compares the version each tick; see Stovokor.idleFrameRate for how an
// idle scene is throttled when nothing has requested a render.
let version = 0
let tracer: ((stack: string) => void) | undefined

/** Ask the engine to draw a frame on the next animation tick */
export function requestRender(): void {
	version++
	if(tracer !== undefined) {
		tracer(new Error().stack ?? "")
	}
}

/**
 * Dev diagnostics: receive the call stack of every render request (an
 * Error is allocated per request while set, so only enable briefly) to find
 * what keeps an idle scene drawing. Pass undefined to stop.
 */
export function setRenderRequestTracer(callback: ((stack: string) => void) | undefined): void {
	tracer = callback
}

/** Monotonic counter of render requests, for the frame loop to compare */
export function renderRequestVersion(): number {
	return version
}
